import React, { useState } from 'react';
import './team section.css';
import TeamMemberModal from './TeamMemberModal';
import zaneHeadshot from '../../assets/zane headshot.jpeg';
import jaggerHeadshot from '../../assets/jagger headshot.jpeg';
import chrisHeadshot from '../../assets/Chris Johnson Headshot.jpeg';

const TeamSection = ({ onLearnMore }) => {
  const [selectedMember, setSelectedMember] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (member) => {
    setSelectedMember(member);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedMember(null);
  };

  const teamMembers = [
    {
      id: 1,
      name: 'Zane Schartz',
      firstName: 'Zane',
      position: 'Founder',
      position2: 'Fund Manager',
      bio: 'Zane Schartz is a founder of Real World Equity. He is also the President and Founder of Freedom Commercial Real Estate. With over 9 years of expertise in private equity real estate investing, Zane has managed a portfolio of six commercial real estate funds and over 70 assets, totaling more than $700 million in assets under management. He\'s also a partner in $300 million worth of commercial real estate and directly oversees $175 million in commercial assets. Zane\'s approach focuses on using innovative strategies and relationships to maximize investor returns and create lasting wealth.\n\nA former professional hockey player, Zane graduated from Liberty University with a degree in business marketing and management. After graduation, he went on to play professional hockey for three years in North America and Europe. Zane attends Eastside Community Church in Dallas, TX. His biggest goal in life is to create a non-profit organization that funds Christian missionaries around the world.',
      image: zaneHeadshot,
      linkedin: 'https://www.linkedin.com/in/zaneschartz/',
      twitter: 'https://twitter.com/zaneschartz',
      youtube: 'https://www.youtube.com/@ZaneSchartzRE'
    },
    {
      id: 2,
      name: 'Chris Johnson',
      firstName: 'Chris',
      position: 'Founder',
      position2: 'Strategic Advisor',
      bio: 'Chris has a passion for solving problems and building teams. He is an 8x founder all with successful outcomes, including his first start up that battled from bootstrap to a $90M enterprise. His experience is broad: from smart home tech and custom software systems, to marble and granite imports and commercial electrical systems. He is currently working with a team to simplify the way we monitor and track remote assets.\n\nChris has led teams responsible for the execution of marketing, lead generation, sales, product management, custom software development, customer support, and finance. His drive for growth has been enabled by a customer-centric philosophy and a data-driven approach to decision making.\n\nHis passion for building is second only to life with his wonderful wife and six amazing children, who let him pretend to be a chef at home on the weekends.',
      image: chrisHeadshot,
      linkedin: 'https://www.linkedin.com/in/chrisjohnsonalarm/',
      twitter: 'https://twitter.com/chrisjohnson',
      youtube: 'https://youtube.com/@chrisjohnson',
      hiddenSocial: ['youtube', 'twitter']
    },
    {
      id: 3,
      name: 'Jagger Luce',
      firstName: 'Jagger',
      position: 'Director of Growth & Partnerships',
      bio: 'Jagger Luce is a dad of two, blockchain strategist, and capital markets expert. As the CEO and Co-Founder of Mustard Capital, he is a leader in investor acquisition and GTM, having developed strategies that have helped clients secure over $1 billion in capital in the past three years. He is also widely recognized as a trusted source of institutional-grade deal flow for investors.\n\nHis work spans collaborations with broker-dealers, investment banks, securities attorneys, PE/VC firms, and family offices, giving him a unique vantage point at the intersection of traditional finance and blockchain innovation.\n\nJagger is at the forefront of advancing asset and equity tokenization, where his vision and expertise are redefining how investors access, evaluate, and engage with capital markets worldwide.',
      image: jaggerHeadshot,
      linkedin: 'https://www.linkedin.com/in/jagger-luce/',
      twitter: 'https://twitter.com/jaggerluce',
      youtube: 'https://www.linkedin.com/in/jagger-luce/',
      hiddenSocial: ['twitter', 'youtube']
    }
  ];

  return (
    <section className="team-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Meet Our Team</h2>
          <p className="section-subtitle">
            Experienced professionals dedicated to{'\n'}revolutionizing real estate investment
          </p>
        </div>
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-card">
              <div className="team-avatar">
                <img src={member.image} alt={member.name + ' headshot'} style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
              </div>
              <div className="team-info">
                <h3 className="team-name">{member.name}</h3>
                <p className="team-position">{member.position}</p>
                {member.position2 && <p className="team-position">{member.position2}</p>}
              </div>
              <div className="team-cta">
                <button
                  className="learn-more-button"
                  onClick={() => openModal(member)}
                >
                  Learn About {member.firstName}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <TeamMemberModal
        member={selectedMember}
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </section>
  );
};

export default TeamSection;
